import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Row
} from 'shards-react';
import SelectInput from '../../common/form/SelectInput';
import TextAreaInput from '../../common/form/TextAreaInput';
import TextInput from '../../common/form/TextInput';
import { sendContact } from './contactActions';

const mapState = (state, ownProps) => ({
  profile: state.firebase.profile,
  loading: state.async.loading
});

const actions = {
  sendContact
};

const validate = combineValidators({
  companyName: isRequired({ message: 'company name is required' }),
  companyAddress1: isRequired('company Address'),
  reportDate: isRequired('reportDate'),
  companyAddressState: isRequired('company state'),
  companyTel: isRequired('company contact number')
});
class ContactForm extends Component {
  render() {
    const {
      submitting,
      pristine,
      handleSubmit,
      sendContact,
      profile
    } = this.props;
    return (
      <Container fluid>
        <Card small className='my-3'>
          <CardHeader className='border-bottom d-flex justify-content-between bg-primary1'>
            <h5 className='m-0'>Contact Form</h5>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit(sendContact)}>
              {profile.email ? (
                ''
              ) : (
                <Row form>
                  <Col className='form-group'>
                    <FormGroup>
                      <label htmlFor='subject'>Name</label>
                      <Field
                        component={TextInput}
                        type='text'
                        name='name'
                        placeholder={' Your name'}
                      />
                    </FormGroup>
                  </Col>
                  <Col className='form-group'>
                    <FormGroup>
                      <label htmlFor='subject'>Email</label>
                      <Field
                        component={TextInput}
                        type='email'
                        name='email'
                        placeholder={' Your email'}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}

              <Row form>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='type'>Type</label>
                    <Field
                      component={SelectInput}
                      type='select'
                      name='type'
                      placeholder={''}
                      options={[
                        { label: 'General Enquiry', value: 'general_enquiry' },
                        { label: 'Support', value: 'support' }
                      ]}
                    />
                  </FormGroup>
                </Col>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='subject'>Subject</label>
                    <Field
                      component={TextInput}
                      type='text'
                      name='subject'
                      placeholder={''}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col>
                  <FormGroup>
                    <label htmlFor='message'>Message</label>
                    <Field
                      component={TextAreaInput}
                      type='textarea'
                      name='message'
                      placeholder={''}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className='home-buttons d-flex w-100 justify-content-between'>
                <Button
                  type='submit'
                  theme='success'
                  disabled={submitting || pristine}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  reduxForm({ form: 'contactForm', validate })
)(ContactForm);
